module.exports = __webpack_public_path__ + "static/img/4.0e4f441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/4.png
// module id = 6sLy
// module chunks = 1